import { useBuildex } from "@/hooks/use-buildex"

const BUILDEX_BLOCKED_ROUTES = ["/dashboard", "/use-cases/enrolment"];
const DEFAULT_ROUTE = "/onboarding/my-data-exchange";

export const useDexGuard = (meta) => {
	const isBuildex = useBuildex();
	if (!isBuildex) return null;

	const currentPath = meta?.location?.currentPath;

	if (BUILDEX_BLOCKED_ROUTES.includes(currentPath)) {
		return DEFAULT_ROUTE;
	}

	return null;
};
